import styled from "styled-components"

export const ContainerActuality = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 14px;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 5px;
  border: 1px solid #d5d5d5;
  box-shadow: rgb(0 0 0 / 16%) 0px 2px 5px;
  padding: 0.5rem 1rem;
  background: #fff;
`

export const Title = styled.div`
  display: flex;
  margin-bottom: 1rem;
  font-weight: bold;
`

export const Description = styled.div`
  margin-bottom: 1rem;
`

export const FileList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  width: 100%;
`

export const File = styled.div`
  height: 40px;
  background-color: white;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  display: grid;
  align-items: center;
  grid-template-columns: 1rem 1fr;
  grid-gap: 0.5rem;
  padding: 0 5px;
  color: ${({ color }) => (color ? color : "#000")};
  white-space: nowrap;
  cursor: pointer;
  transform: scale(0.95);
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px;
  }
  i {
    color: ${({ color }) => (color ? color : "#000")};
  }
  &:hover {
    transform: scale(1);
    background: ${({ color }) => (color ? `${color}3F` : "#0003F")};
  }
`
